import ComponentBase from '../base/component-base';

/**
 * FAQ Item Component
 * Handles accordion functionality for FAQ items
 * Entire item is clickable, except for links and buttons inside
 */
class FaqItem extends ComponentBase {
  private titleElement: HTMLElement | null = null;
  private contentElement: HTMLElement | null = null;
  private onItemClickBinding: (e: Event) => void;
  private onTitleKeydownBinding: (e: KeyboardEvent) => void;

  constructor(element: HTMLElement) {
    super(element);

    console.log('[FaqItem] Initializing FAQ item:', element);

    // Bind event handlers
    this.onItemClickBinding = this.onItemClick.bind(this);
    this.onTitleKeydownBinding = this.onTitleKeydown.bind(this);

    this.init();
  }

  protected init(): void {
    // Find child elements
    this.titleElement = this.element.querySelector('.c-faq-content__item-title');
    this.contentElement = this.element.querySelector('.c-faq-content__item-content');

    if (!this.titleElement || !this.contentElement) {
      console.warn('[FaqItem] Required elements not found');
      return;
    }

    console.log('[FaqItem] Elements found:', {
      title: this.titleElement,
      content: this.contentElement,
    });

    // Add click event listener to entire item
    this.element.addEventListener('click', this.onItemClickBinding);

    // dtは既定でフォーカスできずキーボードで開けないため、ボタンとして振る舞わせる
    const contentId = this.contentElement.id || `${this.element.id || 'faq'}-content`;
    this.contentElement.id = contentId;
    this.titleElement.setAttribute('role', 'button');
    this.titleElement.setAttribute('tabindex', '0');
    this.titleElement.setAttribute('aria-controls', contentId);
    this.titleElement.setAttribute('aria-expanded', 'false');
    this.titleElement.addEventListener('keydown', this.onTitleKeydownBinding);

    console.log('[FaqItem] Event listener attached');
  }

  private onTitleKeydown(e: KeyboardEvent): void {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') {
      return;
    }

    e.preventDefault();
    this.toggle();
  }

  private toggle(): void {
    const willOpen = !this.element.classList.contains('is-open');

    this.element.classList.toggle('is-open', willOpen);
    this.titleElement?.setAttribute('aria-expanded', String(willOpen));
  }

  private onItemClick(e: Event): void {
    const target = e.target as HTMLElement;

    // Check if clicked element is a link or button (or inside one)
    const isInteractiveElement = target.closest('a, button');

    if (isInteractiveElement) {
      console.log('[FaqItem] Interactive element clicked, ignoring toggle');
      return;
    }

    console.log('[FaqItem] Item clicked');

    this.toggle();
  }

  protected onDestroy(): void {
    super.onDestroy();

    this.element.removeEventListener('click', this.onItemClickBinding);
    this.titleElement?.removeEventListener('keydown', this.onTitleKeydownBinding);
  }
}

export default FaqItem;
